import { ElMessage } from 'element-plus'
import { useUserStoreWithOut } from '@/store/modules/user'
import encrypt from '@/utils/encrypt'
import { tdsFetch } from '@/utils/fetch';

const API = {
  workflow: '/api/v1/workflows/run'
}

const getDifyEventError = (data) => {
  if (data?.event === 'error') {
    return data.message || data.error || 'Dify 请求失败'
  }

  const status = data?.data?.status
  if ((data?.event === 'workflow_finished' || data?.event === 'node_finished') && status === 'failed') {
    return data.data?.error || 'Dify 工作流执行失败'
  }

  return ''
}

const createDifyStreamError = (data) => {
  const message = getDifyEventError(data)
  if (!message) return null

  const error = new Error(message)
  error.name = 'DifyStreamError'
  error.event = data?.event
  error.response = data
  return error
}

// 交底书初核
export const fetchWorkflow = (data, headers) => {
  const body = data;
  if (body.inputs) {
    body.inputs.url = process.env.VUE_APP_SERVICE_URL
  }
  return tdsFetch(API.workflow, {
    method: 'POST',
    body,
    headers
  })
}

export const streamFetch = async (url, options = {}, callbacks = {}) => {
  const {
    method = 'POST',
    headers = {},
    body,
    signal,
    ignoreToken = false,
  } = options

  const {
    onData,
    onError,
    onComplete,
    onStart
  } = callbacks

  const userStore = useUserStoreWithOut()

  // 构建请求头
  const requestHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'text/event-stream',
    ...headers
  }

  // 添加认证信息
  if (!requestHeaders['Authorization'] && !ignoreToken) {
    requestHeaders['Authorization'] = `Bearer ${process.env.VUE_APP_TOKEN_CHAT}`
  }

  // 构建请求体
  let requestBody = body
  if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
    requestBody = typeof body === 'string' || body instanceof FormData 
      ? body 
      : JSON.stringify(body)
  }

  try {
    // 开始回调
    if (onStart) {
      onStart()
    }

    const response = await fetch(url, {
      method,
      headers: requestHeaders,
      body: requestBody,
      signal
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    // 处理401未授权
    if (response.status === 401) {
      userStore.setToken(undefined)
      userStore.logout()
      return
    }

    const reader = response.body.getReader()
    let accumulatedData = ''

    while (true) {
      const { done, value } = await reader.read()
      
      if (done) {
        break
      }

      // 将 Uint8Array 转换为文本
      const chunk = new TextDecoder().decode(value)
      accumulatedData += chunk

      // 按行分割处理SSE数据
      const lines = accumulatedData.split('\n')
      accumulatedData = lines.pop() || '' // 保留不完整的行


      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const jsonStr = line.slice(5).trim()
          
          if (jsonStr === '[DONE]') {
            continue
          }

          let data
          try {
            data = JSON.parse(jsonStr)
          } catch (e) {
            console.warn('解析 SSE 数据失败:', e)
            continue
          }

          if (onData) {
            onData(data)
          }
        }
      }
    }

    // 完成回调
    if (onComplete) {
      onComplete()
    }

  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('请求被中止')
      return
    }

    console.error('流式请求失败:', error)
    
    if (onError) {
      onError(error)
    } else {
      ElMessage.error('请求失败')
    }
  }
}

export const streamChat = async (url, data, onMessage, onDone, signal, onError) => {
  return streamFetch(url, {
    method: 'POST',
    body: data,
    signal
  }, {
    onData: (data) => {
      const streamError = createDifyStreamError(data)
      if (streamError) {
        throw streamError
      }

      if (data.event === 'message' && onMessage) {
        console.log(data, 'message')
        onMessage(data)
      }
    },
    onComplete: () => {
      console.log('over')
      onDone?.()
    },
    onError: (error) => {
      console.error('聊天请求失败:', error)
      onError?.(error)
    }
  })
}

/**
 * 创建中止控制器
 * @returns {AbortController}
 */
export const createAbortController = () => {
  return new AbortController()
}

const normalizeRagId = (ragId) => {
  return typeof ragId === 'string' ? ragId.trim() : ''
}

export const CHAT_RAG_ID_MISSING_MESSAGE = '当前项目缺少有效 ragId，请先完成项目知识库生成后再使用 AI 助手。'

export const resolveChatRagId = (ragId) => {
  return normalizeRagId(ragId)
}
